import { useCommandStore } from '../store';

export const useCommandDispatch = () =>
  useCommandStore((state) => state.dispatch);
